import { VscSignOut } from "react-icons/vsc";
import Swal from 'sweetalert2';
import { useAuth } from '../utils/AuthContext';

function Navbar() {
    const { handleUserLogout } = useAuth();

    const exitHandler = async () => {
        const confirm = await Swal.fire({
            icon: 'warning',
            iconColor: 'red',
            title: 'Çıkış yapılsın mı?',
            text: 'Portal oturumunuz kapatılacak. Devam etmek istiyor musunuz?',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Çıkış Yap',
            cancelButtonText: 'Vazgeç',
            customClass: {
                popup: 'bg-slate-900 text-white rounded-2xl',
                title: 'text-base font-semibold',
                htmlContainer: 'text-sm leading-6 text-slate-300',
                confirmButton: 'bg-rose-600 hover:bg-rose-500 text-white text-sm font-semibold rounded-lg',
                cancelButton: 'bg-slate-700 hover:bg-slate-600 text-white text-sm rounded-lg',
                icon: 'text-xs',
            },
        });

        if (confirm.isConfirmed) {
            await handleUserLogout();
        }
    }

    return (
        <nav className="shrink-0 border-b border-slate-800 bg-slate-950 text-white p-4">
            <div className="container mx-auto flex justify-between items-center">
                <div className="flex justify-center items-center">
                    <img src={'/portal_icon.png'} alt="Logo" className="h-10 w-10 mr-1" />
                    <div className="flex flex-col justify-center">
                        <p className="text-cyan-300 text-lg font-medium -mt-1">Portal <span className='text-slate-400 text-xs'>v4.0</span></p>
                        <p className="text-slate-300 text-xs -mt-2">Proforma Onay Programı</p>
                    </div>
                </div>
                <div className="flex items-center gap-3 text-xs text-white">
                    <button className="border border-rose-500/30 bg-rose-600/90 px-3 py-2 rounded-lg hover:bg-rose-500 transition-colors flex flex-row justify-center items-center focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-rose-400/30" onClick={exitHandler}>
                        <VscSignOut className="me-1" size={'16px'} />
                        Çıkış Yap
                    </button>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
